import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import axios from 'axios'
import { getCardStatus } from '../../utils/helpers'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useStore } from '../../store/StoreProvider'
import HasOregonPUCPermitInput from './ModalInputs/HasOregonPUCPermitInput'
import ProductsAuthorizedInput from './ModalInputs/ProductsAuthorizedInput'
import VehicleNumberInput from './ModalInputs/VehicleNumberInput'
import CardLabelInput from './ModalInputs/CardLabelInput'
import DepartmentInput from './ModalInputs/DepartmentInput'
import ModalInformation from './ModalInputs/ModalInformation'
import FillLimitPerPurchaseRadioGroup from './ModalInputs/FillLimitPerPurchaseRadioGroup'
import FillLimitPerPeriodInput from './ModalInputs/FillLimitPerPeriodInput'
import { CardModifiedCb, CardsTableDisplay } from '../../types/types'

const useStyles = makeStyles({
  title: {
    fontWeight: 'bold',
    color: 'black',
  },
  titleOff: {
    fontWeight: 'bold',
    color: '#cfcfcf',
  },
  leftLabel: {
    marginRight: 20,
  },
  flexContainer: {
    display: 'flex',
  },
  formSection: {
    marginTop: 25,
  },
  radio: {
    '&$checked': {
      color: '#ed2224',
    },
  },
  checked: {},
})
interface ModifySingleCardModalProps {
  isOpen: boolean
  handleClose: () => void
  cardBeingModified: CardsTableDisplay
  cardModifiedCb: CardModifiedCb
}

export const ModifySingleCardModal = ({
  isOpen,
  handleClose,
  cardBeingModified,
  cardModifiedCb,
}: ModifySingleCardModalProps) => {
  const classes = useStyles()
  const { user } = useStore()

  const [hasOregonPucPlates, setHasOregonPucPlates] = useState(false)
  const [allProductsAuthorized, setAllProductsAuthorized] = useState(false)
  const [dieselExhaustFluidAuthorized, setDieselExhaustFluidAuthorized] = useState(false)
  const [compressedNaturalGas, setCompressedNaturalGas] = useState(false)

  const [dieselAuthorized, setDieselAuthorized] = useState(false)
  const [oilAuthorized, setOilAuthorized] = useState(false)
  const [unleadedAuthorized, setUnleadedAuthorized] = useState(false)
  const [mediumUnleadedAuthorized, setMediumUnleadedAuthorized] = useState(false)
  const [premiumUnleadedAuthorized, setPremiumUnleadedAuthorized] = useState(false)
  const [offRoadDieselAuthorized, setOffRoadDieselAuthorized] = useState(false)

  const [department, setDepartment] = useState('')
  const [cardLabel, setCardLabel] = useState('')
  const [hasCardRequestBeenMade, setHasCardRequestBeenMade] = useState(false)
  const [fillLimitPerPurchase, setFillLimitPerPurchase] = useState('10')
  const [fillLimitPerPeriod, setFillLimitPerPeriod] = useState('')

  const [errorMessage, setErrorMessage] = useState('')

  const [vehicleNumber, setVehicleNumber] = useState('')

  const [pucPermitNumber, setPucPermitNumber] = useState('')

  useEffect(() => {
    setFillLimitPerPurchase(cardBeingModified.fill_limit_per_purchase)
    setCardLabel(cardBeingModified.card_name)
    setVehicleNumber(cardBeingModified.veh_num.toString())
    setFillLimitPerPurchase(cardBeingModified.fill_limit_per_purchase)
    setDepartment(cardBeingModified.department)
    setFillLimitPerPeriod(cardBeingModified.fill_limit_per_period)
  }, [cardBeingModified])

  const handleSendUpdateRequest = async () => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_ROOT_URL}/cards/changeSingleCard`, {
      spoofedCustomerId: localStorage.getItem('spoofUserId'),
      token: localStorage.getItem('CFN_TOKEN'),
      customerNumber: user?.id,
      vehicleNumber: vehicleNumber,
      hasOregonPucPlates: hasOregonPucPlates,
      pucPermitNumber: pucPermitNumber,
      fillLimitPerPurchase: fillLimitPerPurchase,
      fillLimitPerPeriod: fillLimitPerPeriod,
      areAllProductsAuthorized: allProductsAuthorized,
      isDieselAuthorized: dieselAuthorized,
      isOilAuthorized: oilAuthorized,
      isUnleadedAuthorized: unleadedAuthorized,
      isMediumUnleadedAuthorized: mediumUnleadedAuthorized,
      isPremiumUnleadedAuthorized: premiumUnleadedAuthorized,
      isOffRoadDieselAuthorized: offRoadDieselAuthorized,
      cardLabel: cardLabel,
      department: department,
      isCompressedNaturalGasAuthorized: compressedNaturalGas,
      isDieselExhaustFluidAuthorized: dieselExhaustFluidAuthorized,
      cardNumber: cardBeingModified.card_num,
    })

    if (response.status === 200) {
      cardModifiedCb(cardBeingModified.card_num)
      setHasCardRequestBeenMade(true)
    } else {
      setErrorMessage('*Could Not Create Card Modification Request')
    }
  }

  const handleChangeVehicleNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVehicleNumber(event.target.value)
  }

  const handleChangeDepartment = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDepartment(event.target.value)
  }
  const handleChangeCardLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCardLabel(event.target.value)
  }

  const handleChangeHasOregonPucPlates = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Casting string true/false from form into actual boolean type by using truthy falsy
    const value = event.target.value === 'true'
    setHasOregonPucPlates(value)
  }
  const handleAllProductsAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAllProductsAuthorized(event.target.checked)
  }
  const handleDieselAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDieselAuthorized(event.target.checked)
  }
  const handleDieselExhaustFluidAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDieselExhaustFluidAuthorized(event.target.checked)
  }
  const handleCompressedNaturalGas = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCompressedNaturalGas(event.target.checked)
  }
  const handleOilAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOilAuthorized(event.target.checked)
  }
  const handleUnleadedAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUnleadedAuthorized(event.target.checked)
  }
  const handleMediumUnleadedAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMediumUnleadedAuthorized(event.target.checked)
  }
  const handlePremiumUnleadedAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPremiumUnleadedAuthorized(event.target.checked)
  }
  const handleOffRoadAuthorized = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOffRoadDieselAuthorized(event.target.checked)
  }

  const handleChangePUCPermitNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPucPermitNumber(event.target.value)
  }
  const handleChangeFillLimitPerPurchase = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFillLimitPerPurchase(event.target.value)
  }
  const handleChangeFillLimitPerPeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFillLimitPerPeriod(event.target.value)
  }
  const clearSelections = () => {
    setHasOregonPucPlates(false)
    setAllProductsAuthorized(false)
    setDieselAuthorized(false)
    setDieselExhaustFluidAuthorized(false)
    setCompressedNaturalGas(false)
    setOilAuthorized(false)
    setUnleadedAuthorized(false)
    setMediumUnleadedAuthorized(false)
    setPremiumUnleadedAuthorized(false)
    setOffRoadDieselAuthorized(false)
    setDepartment('')
    setCardLabel('')
    setHasCardRequestBeenMade(false)
    setVehicleNumber('')
    setPucPermitNumber('')
    setHasOregonPucPlates(false)
    setFillLimitPerPurchase('10')
    setFillLimitPerPeriod('')
  }
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        clearSelections()
        handleClose()
      }}
      aria-labelledby="form-dialog-title"
    >
      {!hasCardRequestBeenMade ? (
        <>
          <ValidatorForm onSubmit={handleSendUpdateRequest}>
            <DialogTitle id="form-dialog-title">Modify Single Card Request</DialogTitle>
            <DialogContent>
              <ModalInformation title={'Company Name'} information={user && user.customerName}></ModalInformation>
              <ModalInformation title={'Card Number'} information={cardBeingModified.card_num}></ModalInformation>
              <ModalInformation title={'Card Status'} information={getCardStatus(cardBeingModified.card_status)}></ModalInformation>
              <div className={classes.formSection}>
                <CardLabelInput cardLabel={cardLabel} handleChangeCardLabel={handleChangeCardLabel}></CardLabelInput>
              </div>
              <VehicleNumberInput
                vehicleNumber={vehicleNumber}
                handleChangeVehicleNumber={handleChangeVehicleNumber}
              ></VehicleNumberInput>
              <HasOregonPUCPermitInput
                handleChangePUCPermitNumber={handleChangePUCPermitNumber}
                pucPermitNumber={pucPermitNumber}
                hasOregonPUCPlates={hasOregonPucPlates}
                handleChangeHasOregonPUCPlates={handleChangeHasOregonPucPlates}
              ></HasOregonPUCPermitInput>
              <FillLimitPerPurchaseRadioGroup
                fillLimitPerPurchase={fillLimitPerPurchase}
                handleChangeFillLimitPerPurchase={handleChangeFillLimitPerPurchase}
              ></FillLimitPerPurchaseRadioGroup>
              <FillLimitPerPeriodInput
                fillLimitPeriod={cardBeingModified.fill_limit_period}
                fillLimitPerPeriod={fillLimitPerPeriod}
                handleChangeFillLimitPerPeriod={handleChangeFillLimitPerPeriod}
              ></FillLimitPerPeriodInput>
              <ProductsAuthorizedInput
                dieselExhaustFluid={dieselExhaustFluidAuthorized}
                handleDieselExhaustFluid={handleDieselExhaustFluidAuthorized}
                compressedNaturalGas={compressedNaturalGas}
                handleCompressedNaturalGas={handleCompressedNaturalGas}
                unleadedAuthorized={unleadedAuthorized}
                dieselAuthorized={dieselAuthorized}
                mediumUnleadedAuthorized={mediumUnleadedAuthorized}
                offRoadAuthorized={offRoadDieselAuthorized}
                oilAuthorized={oilAuthorized}
                premiumUnleadedAuthorized={premiumUnleadedAuthorized}
                allProductsAuthorized={allProductsAuthorized}
                handleAllProductsAuthorized={handleAllProductsAuthorized}
                handleDieselAuthorized={handleDieselAuthorized}
                handleOilAuthorized={handleOilAuthorized}
                handleUnleadedAuthorized={handleUnleadedAuthorized}
                handleMediumUnleadedAuthorized={handleMediumUnleadedAuthorized}
                handlePremiumUnleadedAuthorized={handlePremiumUnleadedAuthorized}
                handleOffRoadAuthorized={handleOffRoadAuthorized}
              ></ProductsAuthorizedInput>
              <div className={classes.formSection}>
                <DepartmentInput
                  department={department}
                  handleChangeDepartment={handleChangeDepartment}
                ></DepartmentInput>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  clearSelections()
                  handleClose()
                }}
              >
                Cancel
              </Button>
              <Button type={'submit'}>Request</Button>
            </DialogActions>
          </ValidatorForm>
        </>
      ) : (
        <div>
          <p style={{ padding: 10 }}>New Card Modification Request Sent</p>
          <DialogActions>
            <Button
              onClick={() => {
                clearSelections()
                handleClose()
              }}
            >
              Close
            </Button>
          </DialogActions>
        </div>
      )}
    </Dialog>
  )
}
export default ModifySingleCardModal
